export const allscansData= [
    {
      "id": "SCANC26DF40A",
      "assetTitle": "google.com",
      "category": "Vulnerability Scan",
      "type": "MEDIUM",
      "postedDate": "04 January 2025",
      "lastDate": "04 January 2025",
      "status": "Analyzed",
      "description": "Basic Network Scan for google.com",
      "resolved": true
    },
    {
      "id": "SCAN1D8C674C",
      "assetTitle": "Company3",
      "category": "Vulnerability Scan",
      "type": "CRITICAL",
      "postedDate": "07January 2025",
      "lastDate": "07January 2025",
      "status": "Analyzed",
      "description": "Company3 application sbom",
      "resolved": false
    },
    {
      "id": "SCANA231AAD1",
      "assetTitle": "vulnweb",
      "category": "Vulnerability Scan",
      "type": "INFO",
      "postedDate": "10 January 2025",
      "lastDate": "10 January 2025",
      "status": "Analyzed",
      "description": "Testing for common web vulnerabilities on vulnweb.com",
      "resolved": false
    },
    {
      "id": "SCAN9953FC4A",
      "assetTitle": "Company2",
      "category": "Vulnerability Scan",
      "type": "CRITICAL",
      "postedDate": "10 January 2025",
      "lastDate": "10 January 2025",
      "status": "Analyzed",
      "description": "Company2 application sbom",
      "resolved": true
    },
    {
      "id": "SCAN9EAEC58D",
      "assetTitle": "Company1",
      "category": "Vulnerability Scan",
      "type": "CRITICAL",
      "postedDate": "12 January 2025",
      "lastDate": "12 January 2025",
      "status": "Analyzed",
      "description": "Company1 application sbom",
      "resolved": true
    },
    {
      "id": "SCANE0869145",
      "assetTitle": "Internet Secure org",
      "category": "Vulnerability Scan",
      "type": "MEDIUM",
      "postedDate": "12 January 2025",
      "lastDate": "12 January 2025",
      "status": "Analyzed",
      "description": "testing Internet Secure Org ",
      "resolved": false
    },
    {
      "id": "SCAN7246A50F",
      "assetTitle": "Laravel",
      "category": "Vulnerability Scan",
      "type": "HIGH",
      "postedDate": "1 January 2025",
      "lastDate": "1 January 2025",
      "status": "Analyzed",
      "description": "Sbom Analysis for Laravel",
      "resolved": true
    },
    {
      "id": "SCANDFFD965C",
      "assetTitle": "Java-archive-engine",
      "category": "Vulnerability Scan",
      "type": "CRITICAL",
      "postedDate": "15 January 2025",
      "lastDate": "15 January 2025",
      "status": "Analyzed",
      "description": "Supply chain Management for java libraries",
      "resolved": false
    },
    {
      "id": "SCAN428099A7",
      "assetTitle": "Goinit",
      "category": "Vulnerability Scan",
      "type": "CRITICAL",
      "postedDate": "16 January 2025",
      "lastDate": "16 January 2025",
      "status": "Analyzed",
      "description": "enterprise stack switch",
      "resolved": false
    },
    {
      "id": "SCANF1C1D47A",
      "assetTitle": "edugenie labs",
      "category": "Vulnerability Scan",
      "type": "MEDIUM",
      "postedDate": "17 January 2025",
      "lastDate": "17 January 2025",
      "status": "Analyzed",
      "description": "LMS ",
      "resolved": false
    },
    {
      "id": "MA4429FE57",
      "assetTitle": "Node.js",
      "category": "Malware Scan",
      "type": "INFO",
      "postedDate": "04 January 2025",
      "lastDate": "04 January 2025",
      "status": "Completed",
      "description": "No description available.",
      "resolved": false
    },
    {
      "id": "TMC22D0C",
      "assetTitle": "Web Server - Internal Application Hosting",
      "category": "Threat Modeling",
      "type": "CRITICAL",
      "postedDate": "05 January 2025",
      "lastDate": "05 January 2025",
      "status": "UnApproved",
      "description": "This asset refers to the internal web server that hosts company applications accessible via the internal network. The server runs several services such as a customer portal, an internal API, and a document management system. The server is configured to handle incoming HTTP(S) requests and uses a local database for user and session management.",
      "analysis": "This threat model for the internal web server (TMC22D0C) identifies several significant vulnerabilities across various layers of the OSI model.  The analysis below categorizes threats by layer and highlights the most critical risks:\n\n**High Priority Threats:**\n\n* **Layer 7 (Application):** This layer presents the most significant risks.  The vulnerabilities listed (XSS, SQL Injection, insecure authentication, broken access control, API vulnerabilities) are classic attack vectors for web applications.  Successful exploitation could lead to data breaches, account compromise, application takeover, and potentially broader network compromise.  **Immediate mitigation is crucial.**  This requires robust input validation, parameterized queries (to prevent SQL injection), secure authentication mechanisms (properly configured OAuth), comprehensive access control lists, and secure API design (including rate limiting).  Regular penetration testing and security audits are essential.\n\n* **Layer 5 (Session):** Session hijacking and improper session management are serious threats.  Compromised sessions grant attackers access to user accounts and data without needing to re-authenticate.  Implementing strong session management practices, using secure cookies (HTTPOnly and Secure flags), proper session timeouts, and potentially incorporating mechanisms like CSRF tokens are vital.\n\n* **Layer 4 (Transport):** While TCP SYN flooding is a denial-of-service (DoS) attack, improper SSL/TLS configuration is a more significant threat. Weak cipher suites or misconfigurations can allow eavesdropping and man-in-the-middle attacks, compromising sensitive data transmitted between the client and server.  Regular updates to the server's SSL/TLS certificates and configuration, along with the use of strong cipher suites, are essential.\n\n**Medium Priority Threats:**\n\n* **Layer 6 (Presentation):**  The threats here are mostly related to data encoding and encryption.  While weaknesses in cipher suites are already addressed under Layer 4, input/output encoding issues could lead to data leakage or injection attacks.  Proper encoding and validation of all data are necessary.\n\n* **Layer 3 (Network):**  IP spoofing, DNS poisoning, and insufficient network segmentation are concerning.  These threats could facilitate lateral movement within the network after an initial compromise.  Implementing strong network access controls, robust firewalls, and proper network segmentation are crucial.\n\n\n**Low Priority Threats (depending on the internal network security):**\n\n* **Layer 2 (Data Link):**  MAC address spoofing and rogue DHCP servers are less critical if the internal network has adequate security controls in place.  However, they remain potential entry points, especially if Wi-Fi is used without proper security measures.\n\n* **Layer 1 (Physical):** Physical theft or tampering is a risk, but it's usually mitigated by physical security measures like locked server rooms, access control systems, and surveillance.\n\n\n**Overall Recommendations:**\n\nThe threat model highlights a need for a multi-layered security approach.  Prioritize addressing the high-priority threats at Layers 7, 5, and 4.  This includes:\n\n* **Regular security audits and penetration testing:** To identify and address vulnerabilities proactively.\n* **Secure coding practices:**  To prevent common web application vulnerabilities.\n* **Strong authentication and authorization mechanisms:** To control access to the server and its applications.\n* **Robust network security controls:**  To prevent unauthorized access and lateral movement.\n* **Regular software updates and patching:**  To address known vulnerabilities in the server software and applications.\n* **Incident response plan:**  To handle security breaches effectively.\n\n\nThe \"undefined\" stack makes a thorough assessment challenging. Knowing the specific web server software, database system, and application frameworks would allow for a more precise vulnerability analysis and tailored mitigation strategies.  This information should be added to the threat model.\n",
      "resolved": true
    }
  ]